// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarFinanceiroInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/financeiro/migrar-todas
 * (controllers/migration/financeiro.php::migrar_todas).
 *
 * Um unico campo, OBRIGATORIO: a franquia cuja estrutura financeira vai
 * migrar. Nao existe "todas de uma vez": o export global estoura o limite de
 * execucao do Creator (erro 9430, medido em 2026-08-20).
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido do navegador
 * (armadilha A1).
 */
import { registerContract } from './validate'

export interface Migration_MigrarFinanceiroInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarFinanceiroInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
